import React from "react";
import "./../../UaeAttestation/UaeBlore/UaeBlore.css";
import UaeBloreHead from "../../UaeAttestation/UaeBlore/UaeBloreHead";
import MalaysiaBloreMain from "./MalaysiaBloreMain";
const MalaysiaBlore = () => {
  return (
    <div className="uaeBloreContainer">
      <UaeBloreHead head="Malaysia Attestation in Bangalore" />
      <MalaysiaBloreMain />
    </div>
  );
};

export default MalaysiaBlore;
